document.addEventListener("DOMContentLoaded", function () {
  const contactAccordion = document.querySelector(".footer-block--contact-info");

  if (!contactAccordion) return;

  const heading = contactAccordion.querySelector(".footer-block__heading");
  const content = contactAccordion.querySelector(".footer-block__details-content");

  function toggleAccordion() {
    contactAccordion.classList.toggle("open");
  }

  function checkScreen() {
    if (window.matchMedia("(max-width: 749px)").matches) {
      heading.addEventListener("click", toggleAccordion);
    } else {
      heading.removeEventListener("click", toggleAccordion);
      contactAccordion.classList.add("open");
    }
  }
  checkScreen();
  window.addEventListener("resize", checkScreen);
});
